import { UserModel } from '@/models/user';
import { IApiService, IUserService, UserType } from '@/interfaces/Services';
import { inject, injectable } from 'inversify';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

@injectable()
export default class UserService implements IUserService {
  private _api: IApiService;

  constructor(@inject(DependencyIdentifiers.ApiService) api: IApiService) {
    this._api = api;
  }

  async create(type: UserType, $id: any): Promise<UserModel> {
    const data = {
      type: 'AuthProfile',
      user: { type, $id }
    };
    return await this._api
      .post<{ data: UserModel }>('/users', { data })
      .then(result => result.data);
  }
}
